import React, { useEffect, useState } from 'react';
import { getPaymentItems } from "../../../_mock-api's";
import { axiosInstanceB2B, Toaster } from '@share/utils';
import { Urls } from '@share/constants';

import './style.scss';
import { get } from 'lodash';
import { IntlShape } from 'react-intl';

const CONVERTIONS = {
  ['link']: 'LinkPay',
  ['amazon_pay']: 'AmazonPay',
  ['google_pay']: 'GooglePay',
  ['apple_pay']: 'ApplePay',
};

const PaymentIntegrations: React.FC<{intl: IntlShape}> = ({intl}) => {

  const [activePayments, setActivePayments] = useState<{ [key: string]: boolean }>({});

  const handleToggle = async (label: string) => {
    const paymentStatus = !activePayments[label];
    const updatedPreferences = {
      ...activePayments,
      [label]: !activePayments[label],
    };
    try {
      const response = await axiosInstanceB2B.post(`${Urls.SavePaymentPreference}`, updatedPreferences);
      if (response.status === 200) {
        setActivePayments((prevState) => ({
          ...prevState,
          [label]: !prevState[label],
        }));
        
        Toaster.success(`${label} is now ${paymentStatus ? 'enabled' : 'disabled'}!`);
      }
    } catch (error) {
      console.error('Error toggling payment preference:', error);
    }
  };
  
  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await axiosInstanceB2B.get(`${Urls.GetPaymentPreference}`);
        const preference = response.data.preferences?.find((p: any) => p.key === 'payment_buttons');


        if (preference?.value) {
          const payments = preference?.value?.split(',').map((p: string) => get(CONVERTIONS, `[${p}]`));

          const paymentFlags = paymentItems.map(p => ({ key: p.label, value: payments.includes(p.label) }));
          const preferences = paymentFlags.reduce(
            (acc: { [key: string]: boolean }, item: { key: string, value: boolean }) => {
              acc[item.key] =  item.value;
              return acc;
            },
            {}
          );

          setActivePayments((prevState) => ({ ...prevState, ...preferences }));

        }
        
        /*
        const preferences = response.data.preferences.reduce(
          (acc: { [key: string]: boolean }, item: { key: string, value: string }) => {
            acc[item.key] = item.value.toLowerCase() === 'true';
            return acc;
          },
          {}
        );
        setActivePayments((prevState) => ({ ...prevState, ...preferences }));
        */
      } catch (error) {
        console.error('Error fetching payment preferences:', error);
      }
    };
  
    fetchPaymentData();
  }, []); 
  const paymentItems = getPaymentItems(intl);
  return (
    <section className="pt-1">
      <div className="container">
        <div className="row">
          {paymentItems.map((item) => (
            <div key={item.label} className="card border mb-4 flex-grow-1">
              <div className="card-body">
                <div className="d-md-flex justify-content-md-between align-items-center">
                  <div className="d-flex align-items-center">
                    <img
                      src={item.icon}
                      width="50px"
                      alt={`${item.label} logo`}
                      className="flex-shrink-0 me-3"
                    />
                    <div className="ms-2 pe-2">
                      <h6 className="card-title mb-0">{item.label}</h6>
                      <ul className="nav nav-divider small">
                        <li className="nav-item">{item.description}</li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="form-check form-switch form-check-md d-flex justify-md-content-between justify-content-end"
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={item.label}
                      checked={activePayments[item.label] || false}
                      onChange={() => handleToggle(item.label)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PaymentIntegrations;
